import React from 'react';
import { sustainabilityData } from '../mock';
import { Award, Home, TrendingDown, Thermometer, Droplet, Lightbulb } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  award: Award,
  home: Home,
  'trending-down': TrendingDown,
  thermometer: Thermometer,
  droplet: Droplet,
  lightbulb: Lightbulb
};

const Sustainability = () => {
  return (
    <section id="sustentabilidad" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#0A3A48] mb-4">
            {sustainabilityData.title}
          </h2>
          <div className="w-24 h-1 bg-[#5E8B7E] mx-auto mb-6"></div>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src={sustainabilityData.image}
              alt="Sustentabilidad"
              className="rounded-lg shadow-2xl"
            />
          </div>

          <div>
            <p className="text-xl text-[#4A4A4A] mb-6 leading-relaxed">
              {sustainabilityData.description}
            </p>
            <p className="text-lg text-[#4A4A4A] leading-relaxed">
              {sustainabilityData.services}
            </p>
          </div>
        </div>

        {/* Highlights Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sustainabilityData.highlights.map((highlight, index) => {
            const IconComponent = iconMap[highlight.icon];
            return (
              <Card
                key={index}
                className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-gradient-to-br from-white to-[#5E8B7E]/5"
              >
                <CardContent className="p-6">
                  <div className="flex flex-col items-center text-center">
                    <div className="p-4 bg-[#5E8B7E]/10 rounded-full mb-4">
                      <IconComponent className="text-[#5E8B7E]" size={32} />
                    </div>
                    <h3 className="text-lg font-semibold text-[#0A3A48] mb-2">
                      {highlight.title}
                    </h3>
                    <p className="text-[#4A4A4A] text-sm leading-relaxed">
                      {highlight.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sustainability;